import React from 'react';

import * as ManifestUI from '@project44/manifest-ds';
import { User, useSingleLogout } from '@project44/ui-utils';

export type TLogoutCard = {
  user: User;
  featureIam1057?: boolean;
};

export const LogoutCard = ({
  user,
  featureIam1057,
}: TLogoutCard): React.ReactElement<TLogoutCard> => {
  const { logOutUser } = useSingleLogout();
  const { spaceSmall, fontSizeSmall } = ManifestUI.designTokens;

  const withTransparentBackground: boolean =
    user?.hasAllPermissions(['system-admin:auth:switch-to-any-tenant']) &&
    !!featureIam1057;

  const LogoutCardComponentWrapper = withTransparentBackground
    ? React.Fragment
    : ManifestUI.Card;

  return (
    <LogoutCardComponentWrapper>
      <ManifestUI.Grid
        css={{
          minWidth: '300px',
          width: '100%',
          padding: spaceSmall,
        }}
        role={'presentation'}
        aria-label={
          withTransparentBackground
            ? 'user-logout-card-view-transparent'
            : 'user-logout-card-view'
        }
        columns="repeat(12, 1fr)"
        onClick={logOutUser}
      >
        <ManifestUI.GridItem
          css={{
            display: 'flex',
            flexDirection: 'column',
          }}
          column={11}
        >
          <ManifestUI.Typography variant={'caption'}>
            Logged in as
          </ManifestUI.Typography>{' '}
          <ManifestUI.Typography
            css={{
              textOverflow: 'ellipsis',
            }}
            variant={'subtext'}
          >
            {user.getFullName()}
          </ManifestUI.Typography>{' '}
        </ManifestUI.GridItem>
        <ManifestUI.GridItem
          css={{
            margin: 'auto',
            textAlign: 'center',
          }}
          column={1}
        >
          <ManifestUI.Icon css={{ fontSize: fontSizeSmall }} icon={'logout'} />
        </ManifestUI.GridItem>
      </ManifestUI.Grid>
    </LogoutCardComponentWrapper>
  );
};
